/* iter-53n++ pass 4 — Templates picker dialog wrapper.
 *
 * Exposes the TemplatesPicker as a full-screen modal reachable from the
 * MenuBar (File → New from Template…) and the ActivityBar.
 */
import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { TemplatesPicker } from './TemplatesPicker';

export default function TemplatesPickerDialog({ open, onOpenChange, onNewBlank }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl p-0" data-testid="templates-picker-dialog">
        <TemplatesPicker
          embedded
          onNewBlank={onNewBlank}
          onClose={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
